import { Button, Typography, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {useTheme} from '@mui/material';
import useAuth from '../../hooks/useAuth';

const ProfileOverview = () => {
    const {auth} = useAuth();
    const profile = {
        firstName: auth?.profile?.firstName,
        lastName: auth?.profile?.lastName,
        phoneNumber: auth?.profile?.phone,
        authStatus: auth?.authStatus
    }
    const theme = useTheme();

    return (
        <Button
            variant="contained"
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderRadius: "0",
                alignItems: 'center',
                paddingTop: "14px",
                width: '100%',
                borderBottom: `1px solid ${theme.palette.background.gray}`,
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.default,
                boxShadow: 'none'
            }}
        >
            <AccountCircleIcon
                sx={{ 
                    fontSize: 60,
                    color: theme.palette.background.gray,
                 }}
            />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    width: '100%',
                }}
            >
                <Typography variant='caption'>
                    {!!profile?.firstName ? `${profile.firstName} ${profile.lastName}` : ""}
                </Typography>
                <Typography variant='subtitle'>
                    {profile.phoneNumber ? profile.phoneNumber : ''}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <Typography
                    variant='caption2'
                    sx={{
                        backgroundColor: profile.authStatus === 3 ? theme.palette.success.main : theme.palette.error.main,
                        color: theme.palette.text.white,
                        padding: "8px",
                        borderRadius: "10px"
                    }}
                >
                    {profile.authStatus === 3 ? "احراز هویت شده" : "نیاز به احراز هویت"}
                </Typography>
            </Box>
        </Button>
    );
};

export default ProfileOverview;
